const getters = {
    contacts: (state) => state.contacts,
    contactId: (state) =>state.contactId,
    loading: state => state.loading
};

export default getters;